<template>
    <div>
        <h3
            :class="{ 'is-active': show }"
            class="dropdown-trigger mb-0 py-lg flex items-center justify-between"
            @click="toggle"
        >
            <slot />
            <font-awesome-icon icon="chevron-down" class="chevron ml-sm text-xs text-neutral-darker" />
        </h3>

        <div v-if="show">
            <slot name="subpages" />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            };
        },
        methods: {
            toggle() {
                this.show = ! this.show;
            },
        },
    };
</script>